import { DefaultEnvironment } from 'projects/cart-tv/src/environments/environment.def';

export const localEnvironment = Object.assign<DefaultEnvironment, DefaultEnvironment>(new DefaultEnvironment(), {
    dev: true,
    systemState: 'Seattle',
    apiUrl: 'http://localhost:8080',
    socketUrl: 'https://localhost:8080/ws-endpoint',
    systemSeattleUrl: 'https://sys.acadiacraft.com:20443/',
    systemCaliforniaUrl: 'https://sys.acadiacraft.com:20443/',
  systemCartTvUrl: 'https://sys.acadiacraft.com:20443/cart-tv-test/'
})
